import React from "react";

import styles from "./sortBy.module.scss";

/**
 * The list's ordering, alongside the page size and the pager.
 *
 * It sits in that row rather than under the filter chips because it belongs
 * with the other controls over HOW the list is presented — how many rows, which
 * page, what order — not with the ones deciding WHICH rows.
 *
 * The values are the ones the server whitelists; see SORT_BY_STAGES in
 * adminService. A name the server does not know falls back rather than
 * reaching $sort.
 */
export const SORT_OPTIONS = [
  { value: "latestCreated", label: "Latest created" },
  { value: "oldestCreated", label: "Oldest created" },
  { value: "latestEdited", label: "Latest edited" },
  { value: "oldestEdited", label: "Oldest edited" },
];

const SortBy = ({ value, onChange }) => (
  <div className={styles.sortBy}>
    <label className={styles.label} htmlFor="sort-by">
      Sort by
    </label>
    <select
      id="sort-by"
      className={styles.select}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    >
      {SORT_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

export default SortBy;
